import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { formatPrice } from "../lib/api";
import { useCart } from "../lib/cart";
import { useSEO } from "../lib/seo";

export default function Cart() {
  const { items, subtotal, remove, clear } = useCart();

  useSEO({ title: "Carrito · Maggie Records" });

  return (
    <div className="max-w-[1000px] mx-auto px-5 md:px-10 pt-10 md:pt-14" data-testid="cart-page">
      <div className="border-b border-border pb-5 mb-10 flex items-end justify-between">
        <div>
          <p className="text-xs text-muted-foreground mb-2">Carrito</p>
          <h1 className="text-3xl md:text-4xl font-medium">Tu pedido</h1>
          <p className="text-sm text-muted-foreground mt-1">
            {items.length} {items.length === 1 ? "disco" : "discos"}
          </p>
        </div>
        {items.length > 0 && (
          <button onClick={clear} className="text-xs text-muted-foreground hover:text-foreground" data-testid="cart-clear">
            Vaciar
          </button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="border border-dashed border-border py-16 text-center" data-testid="cart-empty">
          <p className="text-sm text-muted-foreground mb-4">Tu carrito está vacío.</p>
          <Link to="/catalogo" className="vmr-link-underline text-sm">Ver catálogo →</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-2 border border-border divide-y divide-border" data-testid="cart-items">
            {items.map((it) => (
              <div key={it.listing_id} className="flex items-center gap-4 p-4">
                <Link
                  to={`/catalogo/${it.slug}`}
                  className="flex items-center gap-4 flex-1 min-w-0 group"
                  data-testid={`cart-item-link-${it.listing_id}`}
                  title="Volver a la ficha del disco"
                >
                  <img src={it.thumb} alt="" className="w-16 h-16 object-cover bg-[hsl(var(--muted))] group-hover:opacity-80 transition-opacity" />
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-muted-foreground">{it.artist}</p>
                    <p className="text-sm font-medium line-clamp-1 group-hover:text-[hsl(var(--accent))] transition-colors">{it.title}</p>
                    <p className="text-xs text-muted-foreground">{[it.format, it.year].filter(Boolean).join(" · ")}</p>
                  </div>
                </Link>
                <span className="text-sm font-medium tabular-nums">{formatPrice(it.price, it.currency)}</span>
                <button
                  onClick={() => remove(it.listing_id)}
                  aria-label="Quitar"
                  className="p-1.5 text-muted-foreground hover:text-foreground"
                  data-testid={`cart-remove-${it.listing_id}`}
                >
                  <X size={14} />
                </button>
              </div>
            ))}
          </div>

          <aside className="border border-border p-5 h-fit" data-testid="cart-summary">
            <h2 className="text-sm font-medium mb-4">Resumen</h2>
            <div className="flex items-baseline justify-between text-sm mb-1.5">
              <span className="text-muted-foreground">Subtotal</span>
              <span className="tabular-nums">{formatPrice(subtotal, "EUR")}</span>
            </div>
            <p className="text-xs text-muted-foreground mb-5">
              Envío aparte: te lo confirmamos antes de pagar.{" "}
              <Link to="/envios" className="underline underline-offset-4">Ver tarifas</Link>
            </p>
            <Link
              to="/finalizar"
              className="block w-full bg-foreground text-background text-center py-3 text-sm hover:bg-[hsl(var(--accent))] transition-colors"
              data-testid="cart-checkout"
            >
              Hacer pedido →
            </Link>
            <p className="text-[10px] text-muted-foreground mt-3 text-center uppercase tracking-wider">
              Sin pago ahora · te escribimos con el total
            </p>
          </aside>
        </div>
      )}
    </div>
  );
}
